export default "__VITE_ASSET__DMIP9oEQ__"